const DEFAULT_CONFIG = {
  apiBaseUrl: "https://api.catchclicker.com",
  googleClientId:
    "690922537630-o10tlbthubkpvdl0efhdrb1t4icfkb4p.apps.googleusercontent.com",
  individualPageSize: 50,
  teamPageSize: 1000,
  openSessionInNewTab: false,
};

let runtimeConfig = { ...DEFAULT_CONFIG };

export const getRuntimeConfig = () => runtimeConfig;

export const setRuntimeConfig = (config) => {
  runtimeConfig = { ...DEFAULT_CONFIG, ...(config || {}) };
  return runtimeConfig;
};

export const loadRuntimeConfig = async () => {
  if (window?.__APP_CONFIG__ && typeof window.__APP_CONFIG__ === "object") {
    return setRuntimeConfig(window.__APP_CONFIG__);
  }

  try {
    const response = await fetch("/config.json", { cache: "no-store" });
    if (response.ok) {
      const data = await response.json();
      return setRuntimeConfig(data);
    }
  } catch (err) {
    // Fallback to defaults when config is missing or invalid.
  }

  return runtimeConfig;
};
